import { grommet, Text } from "grommet";
import { deepMerge } from "grommet/utils";
import { ThemeType } from "grommet/themes";
import React from "react";

const params = new URLSearchParams(window.location.search.toLocaleLowerCase());

const presenceTheme: ThemeType = {
    global: {
        font: {
            size: "14px",
            family: "HyperLegible",
        },
        colors: {
            /* BEGIN: Color Palette Definition */
            brand: "var(--accent)",
            "light-1": "#f7f7f7",
            "light-2": "#e1e1e1",
            "light-3": "#b1b1b1",
            "dark-1": "#0c0e12",
            "dark-2": "#212224bf",
            "dark-3": "#3b3b3b",
            /* END: Color Palette Definition */
            /* BEGIN: Mapping Colors to Grommet Namespaces */
            background: {
                dark: "dark-1",
                light: "light-1",
            },
            "background-back": {
                dark: "dark-2",
                light: "light-2",
            },
            "background-front": {
                dark: "dark-3",
                light: "light-3",
            },
            "background-contrast": {
                dark: "light-3",
                light: "dark-3",
            },
            control: {
                dark: "brand",
            },
        },
        focus: {
            border: {
                color: "none",
            },
        },
        /* END: Mapping Colors to Grommet Namespaces */
    },
    /* BEGIN: Mapping Colors to Components */
    anchor: {
        color: "text",
        hover: {
            textDecoration: "none",
        },
    },
    button: {
        border: {
            radius: "4px",
            width: "1px",
        },
    },
    grommet: {
        extend: {
            background: params.get("background") || "background-back",
        },
    },
    layer: {
        background: {
            dark: "background",
            light: "background",
        },
    },
    menu: {
        background: {
            dark: "background",
            light: "background",
        },
    },
    tip: {
        content: {
            background: {
                dark: "dark-2",
                light: "light-2",
            },
        },
    },
    text: {
        xsmall: { size: "10px" },
        small: { size: "12px" },
        medium: { size: "14px" },
        large: { size: "16px" },
        xlarge: { size: "18px" },
        xxlarge: { size: "20px" },
    },
    /* END: Mapping Colors to Components */
};

const Theme = deepMerge(grommet, presenceTheme);

export default Theme;
